import "./Skeleton.css";

function Boxes({ count, className, children }) {
  return (
    <div className={className} aria-busy="true" aria-label="Loading">
      {Array.from({ length: count }).map((_, index) => children(index))}
    </div>
  );
}

export function BannerSkeleton() {
  return <div className="sk sk-banner" aria-busy="true" aria-label="Loading" />;
}

export function CategoryRowSkeleton({ count = 3 }) {
  return (
    <Boxes count={count} className="sk-row sk-row-3">
      {(index) => (
        <div className="sk-cat" key={index}>
          <div className="sk sk-line sk-mid" />
          <div className="sk sk-btn" />
        </div>
      )}
    </Boxes>
  );
}

export function ProductRowSkeleton({ count = 4 }) {
  return (
    <Boxes count={count} className="sk-row">
      {(index) => (
        <div className="sk-product" key={index}>
          <div className="sk sk-img" />
          <div className="sk sk-line" />
          <div className="sk sk-line sk-short" />
        </div>
      )}
    </Boxes>
  );
}

export function ProductGridSkeleton({ count = 8 }) {
  return (
    <div className="products_list" aria-busy="true" aria-label="Loading products">
      {Array.from({ length: count }).map((_, index) => (
        <div className="arrivals_box" key={index}>
          <div className="sk sk-img" />
          <div className="arrivals_content">
            <div className="sk sk-line" />
            <div className="sk sk-line sk-short" />
          </div>
        </div>
      ))}
    </div>
  );
}

export function ExploreSkeleton() {
  return (
    <Boxes count={4} className="sk-row">
      {(index) => (
        <div className="sk-explore" key={index}>
          <div className="sk sk-img" />
          <div className="sk sk-line" />
          <div className="sk sk-line sk-mid" />
        </div>
      )}
    </Boxes>
  );
}

export function ProductDetailSkeleton() {
  return (
    <div className="sk-detail" aria-busy="true" aria-label="Loading product">
      <div className="sk sk-hero" />
      <div>
        <div className="sk sk-line sk-title" />
        <div className="sk sk-line" />
        <div className="sk sk-line" />
        <div className="sk sk-line sk-mid" />
        <div className="sk sk-line sk-short" />
        <div className="sk sk-btn" />
      </div>
    </div>
  );
}

export function OrderTableSkeleton({ rows = 6 }) {
  return (
    <div className="sk-table" aria-busy="true" aria-label="Loading orders">
      <div className="sk sk-head" />
      {Array.from({ length: rows }).map((_, index) => (
        <div className="sk sk-rowline" key={index} />
      ))}
    </div>
  );
}

export function OrderDetailSkeleton() {
  return (
    <div className="sk-order" aria-busy="true" aria-label="Loading order">
      <div className="sk sk-line sk-title" />
      <div className="sk-row sk-row-3">
        <div className="sk sk-block" />
        <div className="sk sk-block" />
        <div className="sk sk-block" />
      </div>
      <div className="sk sk-rowline" />
      <div className="sk sk-rowline" />
      <div className="sk sk-rowline" />
    </div>
  );
}

export function CartSkeleton() {
  return (
    <div aria-busy="true" aria-label="Loading cart">
      {Array.from({ length: 3 }).map((_, index) => (
        <div className="sk-cart-item" key={index}>
          <div className="sk sk-thumb" />
          <div style={{ flex: 1 }}>
            <div className="sk sk-line" />
            <div className="sk sk-line sk-short" />
          </div>
        </div>
      ))}
    </div>
  );
}
